<div
  class="sign-upload-container"
  [class.sign-upload-container__unique]="!isQuillSignPossible"
>
  @if (incorrectFileTypeError$ | async) {
  <div style="color: #400230; font-weight: bold">
    {{ 'employee.user-agreement-sign.incorrect-file-type' | translate }}
  </div>
  }
  {{
    'employee.user-agreement-sign.manual-desc' +
      (isQuillSignPossible ? '' : '-unique') | translate
  }}
  <div class="instruction-line">
    <div class="instruction-line__title">
      <span class="instruction-line__number">1</span>
      <span>
        {{ 'employee.user-agreement-sign.manual-step1' | translate }}</span
      >
    </div>
    <button
      aria-label="Download button"
      class="instruction-line__button"
      matMiniFab
      (click)="onUserAgreementFileDownload()"
    >
      <mat-icon>cloud_download</mat-icon>
    </button>
  </div>
  <div class="instruction-line">
    <div class="instruction-line__title">
      <span class="instruction-line__number">2</span>
      <span>
        {{ 'employee.user-agreement-sign.manual-step2' | translate }}</span
      >
    </div>
  </div>
  <div class="instruction-line">
    <div class="instruction-line__title">
      <span class="instruction-line__number">3</span>
      <span>
        {{ 'employee.user-agreement-sign.manual-step3' | translate }}</span
      >
    </div>
    <div>
      <button
        aria-label="Upload button"
        class="instruction-line__button"
        matMiniFab
        (click)="fileUserAgreementUpload.click()"
      >
        <mat-icon>cloud_upload</mat-icon>
      </button>
      <input
        #fileUserAgreementUpload
        accept="application/pdf"
        style="display: none"
        type="file"
        (change)="onUserAgreementFileChange(fileUserAgreementUpload.files)"
      />
    </div>
  </div>
  <div class="fo-mt-20">
    <a
      download
      style="color: #400230; font-weight: bold"
      target="_blank"
      [href]="staticUserAgreementHowTo"
      >{{ 'employee.user-agreement-sign.how-to' | translate }}</a
    >
  </div>
  <div class="fo-mt-10">
    <a
      style="
        color: #400230;
        cursor: pointer;
        font-weight: bold;
        text-decoration: underline;
      "
      (click)="onGeneralPolicyDownload()"
      >{{ 'employee.user-agreement-sign.general-policy' | translate }}</a
    >
  </div>
</div>
